/* ------------------------------------------- */
/*   Queries for approver search
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import { getRESTQuery, postRESTQuery } from 'AppSrc/core/queries/axios-queries';

// Get a list of approver groups for network type
// type: one of 'mobile' or 'fixed'
const getApproverGroups = (network) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.groups.list}`;
  const params = {
    network,
    group_type: '7000',
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};

// Get a list of Approver for network type and group id
const getApproversGroupMembers = (network, groupId) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.groups.members}`;
  const params = {
    network,
    group_id: groupId,
    group_type: '7000', // For assignment approval, group_type should be 7000.
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};

// NOT used yet. Individual approvers will be added in phase 3
const addApprover = ({
  id, // id of approver
  network,
  crqId,
}) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.approvers.add}`;
  const params = {
    network,
    crq_id: crqId,
    id,
    // TODO send up firstName, lastName and group, when we implement adding individual approvers
  };
  return postRESTQuery(endpoint, params)
    .then((response) => {
      console.log('addApprover RESPONSE: ', response);
      return response.data;
    });
};

const addApproverGroup = ({
  id, // id of approver group
  network,
  crqId,
}) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.approversGroups.add}`;
  const params = {
    network,
    crq_id: crqId,
    group_id: id ? id : 'SGP000000050151', // passing the desired group id for mobile communications check for risk level 3 and 4..
  };
  return postRESTQuery(endpoint, params)
    .then((response) => response.data);
};



export {
  getApproverGroups,
  addApprover,
  addApproverGroup,
  getApproversGroupMembers,
};

